// Design System
import { DEPRECATED_UnitInput as UnitInput } from 'jl-design-system/elements/unit-input/UnitInput';

// Checkout Forms
import { numbersPositiveOnly } from 'checkout-forms/form/normalizers/restrictInput';
import { numbersPositiveRegex } from 'checkout-forms/form/regex';

// Types
import { ProductProps } from 'types/Product.types';

export function calcMaxValueFromAvailability(stockLevel: string | undefined, quantityLimit: string | undefined = '0') {
  const limit = parseInt(quantityLimit, 10);
  const stock = Number(stockLevel);
  const lowestValue = Math.min(limit, stock);

  // return whichever is lowest, stock level or quantity limit
  if (Number.isInteger(lowestValue)) return lowestValue;

  // if there's a quantity limit, return this
  if (Number.isInteger(limit)) return limit;

  // return the stock level
  return stock;
}

export const ITEM_QUANTITY_FORM = 'itemQuantityForm';
export const ITEM_QUANTITY_INPUT_ID = 'itemQuantity';
export function getFormId(id: string) {
  return `${ITEM_QUANTITY_FORM}-${id}`;
}

export default function getItemQuantityFormConfig({
  changeHandler,
  editBasket,
  isItemFabric = false,
  item,
}: {
  changeHandler?: (value: string) => void;
  editBasket?: boolean;
  isItemFabric?: boolean;
  item: Partial<ProductProps>;
}) {
  const { id = '', availability: { stockLevel, quantityLimit } = {} } = item;
  const selectMaxValue = calcMaxValueFromAvailability(stockLevel, quantityLimit);

  if (isItemFabric) {
    let debounceTimeout: ReturnType<typeof setTimeout> | null = null;
    const debouncedChangeHandler = (event: { target: { value: any } }) => {
      const inputValue = event.target.value;

      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      if (typeof changeHandler === 'function') {
        debounceTimeout = setTimeout(() => {
          changeHandler(inputValue);
        }, 500);
      }
    };

    return {
      id: getFormId(id),
      fields: [
        {
          component: UnitInput,
          id: ITEM_QUANTITY_INPUT_ID,
          label: 'Quantity',
          name: ITEM_QUANTITY_INPUT_ID,
          normalize: editBasket ? undefined : numbersPositiveOnly,
          onChange: debouncedChangeHandler,
          type: 'tel',
          maxLength: 3,
          regex: numbersPositiveRegex,
          required: true,
          selectMaxThreshold: 10,
          validationMessageKeys: {
            maxLength: 'Please enter a number between 1 and 999',
            regex: 'Please enter a number between 1 and 999',
          },
          unitText: 'metre(s)',
          props: {
            id: `${ITEM_QUANTITY_INPUT_ID}-${id}`,
            name: `${ITEM_QUANTITY_INPUT_ID}-${id}`,
          },
        },
      ],
    };
  }

  return {
    id: getFormId(id),
    maxValue: selectMaxValue,
  };
}
